import Vue from "vue";
import Router from "vue-router";
import FullPage from "./views/FullPage.vue";

Vue.use(Router);


export default new Router({
  routes: [
    {
      path: "/",
      name: "fullpage",
      component: FullPage
    },
    {
      path: "/Bizziice",
      name: "Bizziice",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Bizziice.vue")
    },
    {
      path: "/Stuttgart-Airport-City",
      name: "sac",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
          import(/* webpackChunkName: "about" */ "./views/SAC.vue")
    },
    {
      path: "/MJS-Air-Klima",
      name: "MJS Air Klima",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Airklima.vue")
    },
    {
      path: "/Stray",
      name: "Stray",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
          import(/* webpackChunkName: "about" */ "./views/Stray.vue")
    },
    {
      path: "/Gerch-Group",
      name: "gerch",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
          import(/* webpackChunkName: "about" */ "./views/Gerch.vue")
    },
    {
      path: "/Posters",
      name: "Posters",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
          import(/* webpackChunkName: "about" */ "./views/Posters.vue")
    },
    {
      path: "/Millemedia",
      name: "Millemedia",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
          import(/* webpackChunkName: "about" */ "./views/Millemedia.vue")
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    let position = { x: 0, y: 0 }
    // Keep scroll position when using browser buttons
    if (savedPosition) {
      position = savedPosition
    }

    // Workaround for transitions scrolling to the top of the page
    // However, there are still some problems being fixed by the vue team
    // eslint-disable-next-line no-unused-vars
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(position)
      }, 1)
    })
  }
});
